import { InformationList } from "@/api/information";

export const getLastInformation = (information?: InformationList) => {
  return information?.information_list?.toSorted((a, b) =>
    new Date(a.modified) < new Date(b.modified) ? 1 : -1
  )[0];
};
